import { render, staticRenderFns } from "./YourDataIsSafeForm.vue?vue&type=template&id=21c84ad8&scoped=true"
import script from "./YourDataIsSafeForm.vue?vue&type=script&lang=js"
export * from "./YourDataIsSafeForm.vue?vue&type=script&lang=js"
import style0 from "./YourDataIsSafeForm.vue?vue&type=style&index=0&id=21c84ad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c84ad8",
  null
  
)

export default component.exports